import { Environment } from 'src/app/models/environment';

export const environment: Environment = {
  name: 'local',
  production: false,
  emulator: true,
  firebase: {
    apiKey: 'AIzaSyDXWpLC3rsnSVQcphtmQbzjwJ4U_ttJ808',
    authDomain: 'fitscan-ai-dev.firebaseapp.com',
    projectId: 'fitscan-ai-dev',
    storageBucket: 'fitscan-ai-dev.firebasestorage.app',
    messagingSenderId: '198509188301',
    appId: '1:198509188301:web:cbe96ba05b890cd6028584',
    measurementId: 'G-V1EG287LMK',
  },
};
